/**
 * Created by Bowen Li on 06/15/2020.
 *  Description: Contact Detail Template
 * ------ maintenance history ------
 */
import { Component, OnInit, Input, ViewChild } from '@angular/core';


@Component({
    selector: 'tam-contact-detail-template',
    templateUrl: './contact-detail-template.component.html',
    styleUrls: ['./contact-detail-template.component.scss']
})
export class ContactDetailTemplateComponent implements OnInit {
    @Input() config;
    @ViewChild('panel') panel: any;
    constructor(

    ) { }

    ngOnInit() {
    }
    getContactTaskData() {
        this.panel.getContactTaskData();
    }
    getEventAndNoteData() {
        this.panel.getEventAndNoteData();
    }




}
